import React from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import classNames from 'classnames';

// Utils
import { getElementId } from '../../../../../../common/elements/utils/elementPropertyUtils';
import { getSelectedTaskIdSelector } from '../../../selector/selectionToolsSelector';

// Components
import ToolbarPopup from '../../toolbarPopup/ToolbarPopup';

// Constants
import { PopupIds } from '../../../../../components/popupPanel/popupConstants';
import { TooltipAlignment } from '../../../../../components/tooltips/tooltipConstants';
import ReactionsPopupContent from '../../../../../element/reactions/popup/ReactionsPopupContent';
import { getPlatformFormFactorSelector } from '../../../../../platform/platformSelector';

const mapStateToProps = createStructuredSelector({
    selectedTaskListId: getSelectedTaskIdSelector,
});

const ReactionPopupContainer = ({ isPopupOpen, selectedElements, selectedTaskListId, ...props }) => {
    const elementIds = selectedElements.map(getElementId).toArray();

    const focusElementIds = selectedTaskListId ? [selectedTaskListId] : elementIds;

    const deviceFormFactor = useSelector(getPlatformFormFactorSelector);

    return (
        <ToolbarPopup
            {...props}
            alignment={TooltipAlignment.CENTER}
            popupId={PopupIds.REACTION_TOOL}
            className={classNames('ReactionPopup', deviceFormFactor)}
        >
            <ReactionsPopupContent {...props} closePopup={null} elementIds={focusElementIds} />
        </ToolbarPopup>
    );
};

ReactionPopupContainer.propTypes = {
    isPopupOpen: PropTypes.bool,
    selectedElements: PropTypes.object,
    selectedTaskListId: PropTypes.string,
};

export default connect(mapStateToProps)(ReactionPopupContainer);
